import { Popover } from '@systemeio/ui'
import { NewsletterSplitTestApiInterface } from 'modules/newsletters/single/types/newsletter-interface'
import { getNewslettersEditorNextjsUrl } from 'modules/newsletters/single/utils/get-newsletters-editor-nextjs-url'
import { MailingSplitTestStatusTypeEnum } from 'modules/newsletters/split-test/enum/mailing-split-test-status-type-enum'
import { NewsletterSplitTestInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import {
  CheckCircleIcon,
  CloseCircleIcon,
  InfoIcon,
  SplitTestIcon,
  SplitTestRunIcon,
} from '@systemeio/ui/icons'

export const getNewsletterSplitTestColumnTitle = (
  newsletterWithSplitTest: NewsletterSplitTestApiInterface,
  t: TLocoType,
) => {
  const getColor = (colorStatusCreated: string) => {
    switch (newsletterWithSplitTest.mailingSplitTest.status) {
      case MailingSplitTestStatusTypeEnum.Created:
        return colorStatusCreated
      case MailingSplitTestStatusTypeEnum.Running:
        return 'brand-primary'
      case MailingSplitTestStatusTypeEnum.Failed:
      case MailingSplitTestStatusTypeEnum.Interrupted:
        return 'danger'
      case MailingSplitTestStatusTypeEnum.Completed:
        return 'green'
      case MailingSplitTestStatusTypeEnum.Interrupted:
        return 'yellow'
    }
  }

  return (
    <div className={'flex w-full flex-col truncate lg:w-auto'}>
      <LinkWithoutPrefetch
        className={`mb-2 flex items-center gap-1.5 border border-${getColor(
          'text-secondary/30',
        )} w-fit whitespace-nowrap rounded-xl px-1 py-1`}
        href={getNewslettersEditorNextjsUrl(newsletterWithSplitTest.id)}
      >
        <SplitTestIcon className={`fill-${getColor('fill-primary')}`} />
        <span className={`text-${getColor('text-tertiary')}`}>
          {t('dashboard.newsletter.split_test.title')}
        </span>
      </LinkWithoutPrefetch>
      <div className={'flex flex-col gap-1'}>
        <div className={'flex items-center gap-1.5'}>
          <span>{t('dashboard.newsletter.split_test.variant_a')}</span>
          {newsletterWithSplitTest.mailingSplitTest.mailingWinnerSourceId ===
            newsletterWithSplitTest.mailingSplitTest.mailingVariantA.id && (
            <div className={'border-text-secondary/30 flex items-center gap-1 border-l pl-1.5'}>
              <CheckCircleIcon className="fill-green h-[14px] w-[14px]" />
              <span> {t('dashboard.newsletter.split_test.variant_winner')}</span>
            </div>
          )}
        </div>
        <LinkWithoutPrefetch
          className="primary-link w-fit"
          href={`${getNewslettersEditorNextjsUrl(newsletterWithSplitTest.id)}?variant=${
            newsletterWithSplitTest.mailingSplitTest.mailingVariantA.id
          }`}
        >
          {newsletterWithSplitTest.mailingSplitTest.mailingVariantA.currentEmail.subject}
        </LinkWithoutPrefetch>
      </div>
      <hr className="border-text-primary/15 my-2 border-solid" />
      <div className={'flex flex-col gap-1'}>
        <div className={'flex items-center gap-1.5'}>
          <span>{t('dashboard.newsletter.split_test.variant_b')}</span>
          {newsletterWithSplitTest.mailingSplitTest.mailingWinnerSourceId ===
            newsletterWithSplitTest.mailingSplitTest.mailingVariantB.id && (
            <div className={'border-text-secondary/30 flex items-center gap-1 border-l pl-1.5'}>
              <CheckCircleIcon className="fill-green h-[14px] w-[14px]" />
              <span> {t('dashboard.newsletter.split_test.variant_winner')}</span>
            </div>
          )}
        </div>
        <LinkWithoutPrefetch
          className="primary-link w-fit"
          href={`${getNewslettersEditorNextjsUrl(newsletterWithSplitTest.id)}?variant=${
            newsletterWithSplitTest.mailingSplitTest.mailingVariantB.id
          }`}
        >
          {newsletterWithSplitTest.mailingSplitTest.mailingVariantB.currentEmail.subject}
        </LinkWithoutPrefetch>
      </div>
    </div>
  )
}

export const getNewsletterSplitTestStatus = (
  mailingSplitTest: NewsletterSplitTestInterface,
  t: TLocoType,
) => {
  const classNameIcon = 'shrink-0 w-[16px] sm:w-[20px] h-[16px] sm:h-[20px]'

  switch (mailingSplitTest.status) {
    case MailingSplitTestStatusTypeEnum.Created: {
      return <SplitTestRunIcon className={`${classNameIcon} fill-fill-primary`} />
    }
    case MailingSplitTestStatusTypeEnum.Running: {
      return <SplitTestRunIcon className={`${classNameIcon} fill-brand-primary`} />
    }
    case MailingSplitTestStatusTypeEnum.Failed: {
      return (
        <Popover label={t('dashboard.newsletter.split_test.status_failed')}>
          {() => <InfoIcon className={`${classNameIcon} fill-danger`} />}
        </Popover>
      )
    }
    case MailingSplitTestStatusTypeEnum.Interrupted: {
      return (
        <Popover label={t('dashboard.newsletter_editor.split_test.interrupt.success')}>
          {() => <CloseCircleIcon className={`${classNameIcon} fill-danger`} />}
        </Popover>
      )
    }
    case MailingSplitTestStatusTypeEnum.Completed: {
      return <SplitTestRunIcon className={`${classNameIcon} fill-green`} />
    }
  }
}
